import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initNativeFeatures } from "./lib/native-setup";

// Apply stored theme immediately to avoid flash
const storedTheme = localStorage.getItem("trades-toolbelt-theme") || "dark";
document.documentElement.classList.add(storedTheme);

// Initialize native iOS features (status bar, splash screen)
initNativeFeatures();

createRoot(document.getElementById("root")!).render(<App />);
